import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation } from "react-router-dom";

import { WindowTitle } from "../../components/WindowTitle";
import CustomerActivityListComponent from "./views/CustomerActivityList";

const CustomerActivityReportList: React.FC = () => {
  const location = useLocation();
  const params = parseQs(location.search.substr(1));

  return <CustomerActivityListComponent params={params} />;
};

const Component = () => {
  const intl = useIntl();
  return (
    <>
      <WindowTitle
        title={intl.formatMessage({
          defaultMessage: "Customer Information",
          description: "customer info section"
        })}
      />
      <Routes>
        <Route path={""} element={<CustomerActivityReportList />} />
      </Routes>
    </>
  );
};

export default Component;
